<template>
  <div v-if="isVisible" class="mt-0 sm:mt-4 p-2 bg-markencode-blue text-sm  text-gray-100 text-center">
    <p class="leading-4">Ansicht als {{ $page.props.auth.user.name }} <span v-if="$page.props.auth.user.partner_name">({{ $page.props.auth.user.partner_name }})</span>
    |
    <a
      :href="route('admin.users.impersonation.leave')"
      class="hover:text-white focus:outline-none"
    >Ansicht beenden</a>
  </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: this.$page.props.auth.user.is.impersonating
    };
  }
};
</script>